import { useState } from 'react';
import noAvailableImg from '@/assets/img/noFarmerImg.png';
import calendarSvg from '@/assets/svg/calendar.svg';
import locationSvg from '@/assets/svg/location.svg';
import {
  Box,
  Container,
  Dots,
  FarmerDetails,
  FarmerImage,
  FarmerInfo,
  FarmerName,
  Wrapper,
} from '@/components/FarmerCard/FarmerCard.styles';
import { formatDate, isValidDate } from '@/constants/formatDate';

interface Farmer {
  profile_photo?: string;
  first_name?: string;
  last_name?: string;
  location: string;
  registration_date: string;
  farmer_group?: string;
  coffee_variety?: string;
  plots_number?: string | number;
  plot_size?: string | number;
  seedlings_planted?: string | number;
  trainings?: string;
  lirp_price?: string;
  moyee_price?: string;
  yield_2022?: number;
  yield_2023?: number;
  value_2022?: number;
  value_2023?: number;
}

interface FarmerCardProps {
  data: Farmer;
  onClick?: (data: Farmer) => void;
  type: 'grid' | 'details';
}

export const FarmerCard = ({ data, onClick, type }: FarmerCardProps) => {
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState(data?.profile_photo ?? noAvailableImg);

  if (!data) {
    return <p>Loading...</p>;
  }

  const fullName =
    data.first_name && data.last_name ? `${data.first_name} ${data.last_name}` : 'Farmer Name';

  return (
    <Container onClick={onClick ? () => onClick(data) : undefined} type={type}>
      {isImageLoading && (
        <Wrapper>
          <Dots />
        </Wrapper>
      )}
      <FarmerImage
        src={imageSrc}
        onLoad={() => setIsImageLoading(false)}
        onError={() => setImageSrc(noAvailableImg)}
      />
      <FarmerInfo>
        <FarmerName>{fullName}</FarmerName>
        <Box type={type}>
          <FarmerDetails>
            <img src={locationSvg} />
            <p>{data.location}</p>
          </FarmerDetails>
          {isValidDate(data.registration_date) && (
            <FarmerDetails>
              <img src={calendarSvg} />
              <p>Since {formatDate(data.registration_date)}</p>
            </FarmerDetails>
          )}
        </Box>
      </FarmerInfo>
    </Container>
  );
};
